export default __webpack_public_path__ + "static/12_32-0063361b740d4a576940e255d52b5a1c.png";